import React, { useEffect, useState } from 'react';
import './VideoModal.css';

const isYouTubeUrl = (url) =>
  /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\//.test(url);

const isDailymotionUrl = (url) =>
  /dailymotion\.com\/embed\/video\//.test(url) || /dai\.ly\//.test(url);

const getDailymotionEmbedUrl = (url) => {
  // If already embed URL, return as is
  if (/dailymotion\.com\/embed\/video\//.test(url)) return url;
  // If short dai.ly link, extract ID
  const match = url.match(/dai\.ly\/([a-zA-Z0-9]+)/);
  if (match) return `https://www.dailymotion.com/embed/video/${match[1]}`;
  // If regular dailymotion link, extract ID
  const regMatch = url.match(/dailymotion\.com\/video\/([a-zA-Z0-9]+)/);
  if (regMatch) return `https://www.dailymotion.com/embed/video/${regMatch[1]}`;
  return url;
};

const VideoModal = ({ videoUrl, open, onClose }) => {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (open) {
      // Delay iframe loading slightly to improve initial page load
      const timer = setTimeout(() => setShouldLoad(true), 100);
      return () => clearTimeout(timer);
    } else {
      setShouldLoad(false);
    }
  }, [open]);

  if (!open) return null;

  const getEmbedUrl = () => {
    if (isYouTubeUrl(videoUrl)) {
      return videoUrl
        .replace('watch?v=', 'embed/')
        .replace('&t=', '?start=')
        .replace('youtu.be/', 'youtube.com/embed/');
    }
    if (isDailymotionUrl(videoUrl)) {
      return getDailymotionEmbedUrl(videoUrl);
    }
    return videoUrl;
  };

  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-content" onClick={e => e.stopPropagation()}>
        <button className="video-modal-close" onClick={onClose}>&times;</button>
        {shouldLoad ? (
          isYouTubeUrl(videoUrl) || isDailymotionUrl(videoUrl) ? (
            <iframe
              width="100%"
              height="400"
              src={getEmbedUrl()}
              title="Video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
              allowFullScreen
              loading="lazy"
            />
          ) : (
            <video 
              src={videoUrl} 
              controls 
              autoPlay 
              style={{ width: '100%', maxHeight: 400, background: '#000' }} 
            />
          )
        ) : (
          <div style={{ 
            width: '100%', 
            height: 400, 
            background: '#000', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            color: '#fff' 
          }}>
            Loading...
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(VideoModal);